// 任务业务公共方法

import { UserInfoType, RouterType } from "@/@types";
import { useGlobalStore } from "@/store/global";

// 0.1> 获取环境变量 ---------------------------------------------------------------------------------------------------
const getEnvVar = (name: string): string => {
    const globalStore = useGlobalStore();
    const item = globalStore.config.find((item) => item["name"] === name);
    if (item) {
        return item.value;
    } else {
        console.error(`环境变量${name}不存在~`);
        return "";
    }
};

// 1.0> 登录 -----------------------------------------------------------------------------------------------------------
const logIn = (token: string, signKey?: string | null) => {
    localStorage.setItem("token", token);
    const globalStore = useGlobalStore();
    globalStore.userInfo = null;
    if (signKey) {
        localStorage.setItem("signKey", signKey);
    } else {
        localStorage.removeItem("signKey");
    }
};

// 1.1> 退出登录
const signOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("signKey");
    const globalStore = useGlobalStore();
    globalStore.userInfo = null;
    globalStore.routers = [];
};

// 2.0> 获取token ---------------------------------------------------------------------------------------------------
const getToken = (): string | null => {
    return localStorage.getItem("token");
};

// 2.1> 获取签名密钥
const getSignKey = (): string | null => {
    return localStorage.getItem("signKey");
};

// 3.0> 获取当前登录用户的信息（含 loginMode） --------------------------------------------------------------------------------------
const getUserInfo = async (token: string | null, signKey: string | null): Promise<UserInfoType | null> => {
    const globalStore = useGlobalStore();
    if (globalStore.userInfo && globalStore.userInfo.loginMode != null) {
        return globalStore.userInfo;
    }
    // 没有登录 token 或签名 不请求 /auth/user/info
    if (!token || !signKey) return null;
    const res = await httpGet<any>(ServerType.Base, {
        url: "/auth/user/info",
    });
    globalStore.userInfo = {
        id: String(res.id),
        nickname: res.nickname || res.username || "",
        username: res.username || "",
        email: res.email || "",
        avatar: res.avatar || "",
        role: res.role || "user",
        loginMode: res.loginMode,
        powerBalance: res.powerBalance,
        tenantName: res.tenantName,
        level: res.level,
    };
    return globalStore.userInfo;
};
// 3.1> 同步获取当前用户的信息
const getSynUserInfo = (): UserInfoType | null => {
    const globalStore = useGlobalStore();
    return globalStore.userInfo;
};

// 4.0> 获取页面路由 ------------------------------------------------------------------------------------------------
const getRouters = async (token: string | null): Promise<RouterType[]> => {
    const globalStore = useGlobalStore();
    if (globalStore.routers.length > 0) {
        return globalStore.routers;
    } else {
        if (!token) return [];
        const res = await httpGet<RouterType[]>(ServerType.Base, {
            url: "/getRouters",
        });
        globalStore.routers = res;
        return res;
    }
};
// 4.1> 同步获取页面路由
const getSynRouters = (): RouterType[] => {
    const globalStore = useGlobalStore();
    return globalStore.routers;
};

export default { getEnvVar, logIn, signOut, getToken, getSignKey, getUserInfo, getSynUserInfo, getRouters, getSynRouters };
